import { aiAgentVoiceApi } from '@/api/ai';

export const initAiApiEndpoints = () => {
  aiAgentVoiceApi.endpoint = `call-center/${aiAgentVoiceApi.endpoint}`;
};
